var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCpuCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.01 7.75c-1.25 0-2.27 1.01-2.27 2.27v3.97c0 1.25 1.01 2.27 2.27 2.27h3.97c1.25 0 2.27-1.01 2.27-2.27v-3.97c0-1.26-1.01-2.27-2.27-2.27h-3.97zm2.6 6.78c-.13.23-.37.35-.61.35-.12 0-.25-.03-.35-.09a.693.693 0 0 1-.26-.96l.64-1.11h-.56c-.45 0-.82-.2-1.02-.54-.2-.34-.18-.76.05-1.15l.89-1.55c.2-.34.63-.45.96-.26.34.19.46.62.26.96l-.64 1.11h.56c.45 0 .82.2 1.02.54.2.34.18.76-.05 1.15l-.89 1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0-.42-.33-.75-.75-.75H20v-2.2h1.25c.42 0 .75-.33.75-.75 0-.41-.33-.75-.75-.75h-1.48a4.975 4.975 0 0 0-3.32-3.32V2.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75V4h-2.2V2.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75V4H9.06V2.75a.749.749 0 1 0-1.5 0v1.48a4.97 4.97 0 0 0-3.33 3.32H2.75a.749.749 0 1 0 0 1.5H4v2.2H2.75a.749.749 0 1 0 0 1.5H4v2.2H2.75a.749.749 0 1 0 0 1.5h1.48a4.95 4.95 0 0 0 3.33 3.32v1.48a.749.749 0 1 0 1.5 0V20h2.2v1.25a.749.749 0 1 0 1.5 0V20h2.19v1.25c0 .41.34.75.75.75s.75-.34.75-.75v-1.48a4.975 4.975 0 0 0 3.32-3.32h1.48c.42 0 .75-.34.75-.75 0-.42-.33-.75-.75-.75H20v-2.2h1.25c.42 0 .75-.34.75-.75zm-7.74 5.26H9.74c-1.65 0-3-1.35-3-3V9.74c0-1.65 1.35-3 3-3h4.52c1.65 0 3 1.35 3 3v4.52c0 1.65-1.35 3-3 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCpuCharge);
export default __webpack_public_path__ + "static/media/vuesax-bold-cpu-charge.14095933375ecaa792bb5790c62b4102.svg";
export { ForwardRef as ReactComponent };